import styled from "styled-components";

const DefaultInput = styled.input`
  border-radius: 5px;
  border: solid 1px var(--default-dark-gray);
  outline: none;
  font-size: var(--font-regular);
  width: 100%;
  height: 44px;
  padding: 0 10px;
  color: var(--dark-gray);
  background-color: var(--light-gray);
  margin-top: 8px;

  :disabled {
    background: #dddddd;
  }
`;

export default DefaultInput;
